import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { ConfirmPaymentComponent } from './confirm_payment.component';
import { ConfirmPaymentRoutingModule } from './confirm_payment-routing.module';
import { ConfirmPaymentService } from '../services/confirm_payment.service';
import { DownloadVoucherComponent } from './download/download.component';

@NgModule({
  providers: [ConfirmPaymentService],
  imports: [
    ConfirmPaymentRoutingModule,
    SharedModule
  ],
  declarations: [
    ConfirmPaymentComponent,
    DownloadVoucherComponent
  ]
})
export class ConfirmPaymentModule { }
